<template>
  <div id="app">
    <router-view/>
    <div class="language-switcher">
      <a href="#" @click.prevent="changeLanguage('en')" :class="{ active: $store.state.locale === 'en' }">English</a> | 
      <a href="#" @click.prevent="changeLanguage('zh')" :class="{ active: $store.state.locale === 'zh' }">中文</a> | 
      <a href="#" @click.prevent="changeLanguage('jp')" :class="{ active: $store.state.locale === 'jp' }">日本語</a>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    changeLanguage(locale) {
      this.$store.commit('setLocale', locale);
    }
  }
}
</script>
